export default "__VITE_ASSET__DWNcl4hD__"